module.exports = __webpack_public_path__ + "static/dieti-natura-1e970ce146ff4468d500ec5a9082be81.png";